exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-admin-configurations .list-group-item[data-v-39223b84]{cursor:pointer}.p-admin-configurations .list-group-item.active[data-v-39223b84]{cursor:default;border-color:#3daf73;background-color:#3daf73}", ""]);

// exports
